import { CASHOUT } from "../actions/types";
import { takeLatest, call, put, takeEvery } from "redux-saga/effects";
import { accLoadingFinish } from "../actions/accLoading";
import { loadingFinish } from "../actions/Loading";
import axios from "axios";
import { toast } from "react-toastify";

import {
  fetchBankSuccess,
  fetchAllBanksSuccess,
  verifyBankSuccess,
} from "../actions/Cashout";

import { updateProfile } from "../actions/Settings";

import { authHeader } from "../../lib/authHeader";

import { logout } from "../actions/Auth";
import history from "../../helpers/history";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}agent`;
const headers = authHeader();

function* handleCashoutWallet(action) {
  const apiUrl = `${API_BASE}/cashout/transfer/wallet`;
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiCall = async () => {
    const data = {
      ...action.payload,
      token,
    };
    try {
      const result = await axios.post(apiUrl, data, {
        headers,
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    if (result.data.status === "success") {
      yield put(updateProfile());
      toast.success(result.data.message);
      history.push("/agent/cashout");
    } else {
      let errorMessage = result.data.message;
      toast.error(errorMessage);
      throw errorMessage;
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
    sessionStorage.removeItem("wallet-cashout");
  }
}

// Handles cashout to bank
function* handleCashoutBank({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/cashout/transfer/bank/account`;
  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      yield put(updateProfile());
      toast.success(result.data.message);
      history.push("/agent/cashout");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchBank({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/bank/account/list?user_id=${payload.user_id}`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    yield put(fetchBankSuccess(result.data.data));
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleAddBank({ payload, history }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/bank/account/create`;

  const apiCall = async () => {
    try {
      const result = await axios.post(apiUrl, payload, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      toast.success(result.data.message);
      history.push("/agent/cashout/bank");
    } else {
      toast.error(result.data.message);
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleFetchAllBanks() {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/bank/list`;

  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  try {
    const result = yield call(apiCall);
    yield put(fetchAllBanksSuccess(result.data.data));
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(loadingFinish());
  }
}

function* handleVerifyBank({ payload }) {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const apiUrl = `${API_BASE}/recipient/bank/account/resolve`;
  const apiCall = async () => {
    try {
      const result = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...payload,
        },
      });

      return result;
    } catch (err) {
      throw err;
    }
  };

  try {
    const result = yield call(apiCall);

    if (result.data.status === "success") {
      if (
        result.data.data.data.account_name === "ERROR" ||
        result.data.data.status === false
      ) {
        yield put(verifyBankSuccess(""));
        toast.error("No bank acoount with such details");
      } else {
        yield put(verifyBankSuccess(result.data.data.data.account_name));
      }
    }
  } catch (err) {
    let error;
    if (typeof err === "object" && err.response) {
      if (err.response.status === 401) {
        yield put(logout());
        history.push("/login");
        toast.info("Your session has expired");
      } else if (err.response.data.message) {
        error = err.response.data.message;
      } else {
        error = "An error occured. Pls try again";
      }
    }
    toast.error(error);
  } finally {
    yield put(accLoadingFinish());
  }
}

const cashoutSaga = [
  takeLatest(CASHOUT.CASHOUT_BANK, handleCashoutBank),
  takeLatest(CASHOUT.CASHOUT_WALLET, handleCashoutWallet),
  takeLatest(CASHOUT.FETCH_BANK, handleFetchBank),
  takeEvery(CASHOUT.ADD_BANK, handleAddBank),
  takeEvery(CASHOUT.FETCH_ALL_BANKS, handleFetchAllBanks),
  takeLatest(CASHOUT.VERIFY_BANK, handleVerifyBank),
];

export default cashoutSaga;
